import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {Grid as GridType} from './DataLayoutTypes';
import GridBlock from './GridBlock';

interface GridSectionProps {
  grid: GridType;
  layoutPath: Array<string | number>;
}

/** @package */
export default function GridSection({grid, layoutPath}: GridSectionProps): JSX.Element {
  return (
    <div className={css(styles.grid)}>
      {grid.rows.map((row, rowIndex) => (
        <div className={css(styles.row)} key={`row-${rowIndex}`}>
          {row.map((block, columnIndex) => (
            <GridBlock
              block={block}
              key={`block-${columnIndex}`}
              layoutPath={[...layoutPath, 'grid', 'rows', rowIndex, columnIndex]}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

const DEFAULT_BLOCK_HEIGHT = 400;

const styles = StyleSheet.create({
  grid: {display: 'flex', flexDirection: 'column', gap: 8},
  row: {display: 'flex', flexDirection: 'row', gap: 8, height: DEFAULT_BLOCK_HEIGHT},
});
